import React from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { Table, Typography } from 'antd';
import { useRecoilValueLoadable, useRecoilValue, useRecoilState } from 'recoil';
import { pageAtom, rowsAtom, timezoneAtom } from '../../../../atoms/Atoms';
import { redemptionsSelector } from '../../../../atoms/Selectors';

function Redemptions() {
  const reportData = useRecoilValueLoadable(redemptionsSelector);
  const timezone = useRecoilValue(timezoneAtom);
  const [rows, setRows] = useRecoilState(rowsAtom);
  const [current, setCurrent] = useRecoilState(pageAtom);
  const { t } = useTranslation();

  function mapData(data) {
    const mapped = _.map(data, (p, index) => ({
      key: index,
      amount: p.amount,
      code: p.code,
      confirmationCode: p?.confirmationCode,
      date: p.date,
    }));

    return mapped;
  }

  function toShortDate(date) {
    if (date) {
      return moment(`${date}+0000`).tz(timezone).format('MMMM DD, YYYY');
    }
    return '';
  }

  return (
    <div className="p-4 border bg-gray-100 rounded-lg mb-4">
      <Table
        size="small"
        loading={reportData.state === 'loading'}
        bordered
        scroll={{ x: 500 }}
        pagination={{
          current,
          hideOnSinglePage: true,
          showSizeChanger: true,
          size: 'small',
          pageSize: rows,
          total:
            reportData.state === 'hasValue' &&
            reportData.contents.data.data.total,
          pageSizeOptions: [10, 20, 30, 40, 50],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} ${t('out_of')} ${total} ${t('items')}`,
          onShowSizeChange: (page, size) => {
            setRows(size);
          },
          onChange: (page) => {
            setCurrent(page);
          },
        }}
        columns={[
          {
            title: t('date'),
            dataIndex: 'date',
            key: 'date',
            align: 'right',
            className: 'text-xs',
            render: (text) => <span>{toShortDate(text)}</span>,
          },
          {
            title: t('amount'),
            dataIndex: 'amount',
            key: 'amount',
            align: 'right',
            className: 'text-xs',
            render: (text) => (
              <span>
                {' '}
                $
                {text
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </span>
            ),
            sorter: (a, b) => a.amount - b.amount,
          },
          {
            title: t('discount_code'),
            dataIndex: 'code',
            key: 'code',
            align: 'right',
            className: 'text-xs',
            render: (text) => (
              <Typography.Text copyable>
                <span> {text}</span>{' '}
              </Typography.Text>
            ),
            sorter: (a, b) => a.code - b.code,
          },
        ]}
        dataSource={
          reportData.state === 'hasValue' &&
          mapData(reportData.contents.data.data.results)
        }
      />
    </div>
  );
}

export default Redemptions;
